import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { queryClient, themeConfig } from '@libs/@core/constants/config';
import themeCustomConfig from '@themes/_customize/themeCustomConfig';
import { SnackbarProvider } from '@libs/@core/contexts/snackbarContext';
var RootLayout = function () {
    return (_jsxs(CssVarsProvider, { theme: themeCustomConfig(), defaultMode: 'light', modeStorageKey: "".concat(themeConfig.templateName.toLowerCase().split(' ').join('-'), "-mode"), children: [_jsx(CssBaseline, { enableColorScheme: true }), _jsx(SnackbarProvider, { children: function (snackBar) { return (_jsx(QueryClientProvider, { client: queryClient({ snackBar: snackBar }), children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: _jsx(Outlet, {}) }) }) })); } })] }));
};
export default RootLayout;
